import HeroImageSetting from './HeroImageSetting';

export default HeroImageSetting;
